const colorTokens = require("./tokens/colors.json")
const { getTailwindColorsFromTokens } = require("./utils/getTailwindColorsFromTokens.cjs")

const colors = {
  ...getTailwindColorsFromTokens(colorTokens.color),
  transparent: "transparent",
  inherit: "inherit",
}

module.exports = {
  colors,
}

exports.default = colors
